module.exports = __webpack_public_path__ + "static/img/卡片_选中状态@2x.81ef1fc9.png";